import React from "react";
import { Admin, AppBar, defaultTheme, Layout, Resource, TitlePortal } from "react-admin";
import mainProvider from "../providers/mainProvider";
import defaultAuthProvider from "../providers/authProvider";
import LoginPage from "./LoginPage";
import DashboardPage from "./DashboardPage"
import VideoPage from "./VideoPage"
import { createTheme } from "@mui/material/styles";
import VideoIcon from '@mui/icons-material/VideoLibrary';
import simplemanLogo from "../image/simpleman-white.png";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export default function AdminPanel() {
  const Logo = styled("img")({
    height: 20,
    marginTop: 3
  });

  const MyAppBar = () =>
    <AppBar color="primary">
      <TitlePortal variant="body2" component="h3">
        <Logo src={simplemanLogo} alt="SimpleMan" />
        <Typography style={{ marginLeft: 5, marginTop: 3, fontSize: 14, float: 'right' }}>p.dipede@simpleman.it - 388 824 7836</Typography>
      </TitlePortal>
    </AppBar>;

  const MyLayout = ({ children }) => (
    <Layout appBar={MyAppBar}>
        {children}
    </Layout>
);

  const myTheme = createTheme({
    ...defaultTheme,
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: "#3a5081",
          },
        },
      },
    },
  });

  return (
    <Admin 
      basename="/admin"
      theme={myTheme} 
      layout={MyLayout}
      authProvider={defaultAuthProvider} 
      dataProvider={mainProvider} 
      loginPage={LoginPage}
      dashboard={DashboardPage}>
      <Resource name="video" list={VideoPage} icon={VideoIcon} options={{ label: "Video Tutorial" }} />
    </Admin>
  );
}
